/**
 * DevDash - Developer Dashboard
 *
 * A control surface for debugging, QA, and experimentation.
 *
 * - Non-production (develop, qa, local): enabled automatically, Ctrl+. to toggle
 * - Production: visit ?devdash=true to enable (no password), then Ctrl+. to toggle
 * - Can be disabled globally via env var: NEXT_PUBLIC_DEVDASH_DISABLED=true
 */

// biome-ignore lint/performance/noBarrelFile: DevDash public API barrel file
export { DevDashProvider } from './components/DevDashProvider';
export { useDevDash } from './hooks/useDevDash';
export type { DevDashContextValue, DevDashState } from './types';
export { isDevDashEnabled } from './utils/gating';
